<template>
    <div>
        <top-bar></top-bar>
        <div class="page-register-form">
            <div class="register-title">{{lbl.register.form_register_title}}</div>

            <!-- input gender -->
            <div class="row no-gutters">
                 <div class="col-2"></div>
                 <div class="col-10 gender-register">
                     <div class="col-4 gender-item" @click="ClickRadio('MS')">
                         <img v-if="registerModel.prefix == 'MS'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="registerModel.prefix != 'MS'" src="@/assets/icon/radio-inactive@2x.png" />
                         <div class="gender-name">{{lbl.register.ms}}</div>
                     </div>
                     <div class="col-4 gender-item" @click="ClickRadio('MRS')">
                         <img v-if="registerModel.prefix == 'MRS'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="registerModel.prefix != 'MRS'" src="@/assets/icon/radio-inactive@2x.png" />
                          <div class="gender-name">{{lbl.register.mrs}}</div>
                     </div>
                     <div class="col-4 gender-item" @click="ClickRadio('MR')">
                         <img v-if="registerModel.prefix == 'MR'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="registerModel.prefix != 'MR'" src="@/assets/icon/radio-inactive@2x.png" />
                          <div class="gender-name">{{lbl.register.mr}}</div>
                     </div>
                 </div>
            </div>

            <!-- input first name -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-name@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-text inputId="register-name"
                                v-model="registerModel.firstname"
                                :inputLbl="lbl.register.firstname"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[0]"
                                :isTextOnly="true"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-text>
                </div>
            </div>

            <!-- input last name -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                    </div>
                </div>
                <div class="col-10">
                    <input-text inputId="register-lastname"
                                v-model="registerModel.lastname"
                                :inputLbl="lbl.register.lastname"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[1]"
                                :isTextOnly="true"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-text>
                </div>
            </div>

            <!-- input birthdate -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-birthday@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <dropdown-date :inputLbl="lbl.register.birthdate"
                                   :isFirstSave="isFirstSave"
                                   :errorInfo="errorInfo[2]"
                                   :isFullLbl="true"
                                   :inputDisabledDay="true"
                                   :inputDisabledMonth="true"
                                   :setDay="registerData.day"
                                   :setMonth="registerData.month"
                                   @onChange="onDateChange($event)"
                    ></dropdown-date>
                </div>
            </div>

            <!-- input contact number -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                        <img src="@/assets/img/03-profile/ic-phone@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-contact-number inputId="profile-contactnumber"
                                v-model="registerModel.contactNumber"
                                delimeter="-"
                                :inputLbl="lbl.register.contactnumber"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[3]"
                                :blockAutoComplete="true"
                                :showLabelOnInputOnly="true"
                                :inputDisabled="true"
                    ></input-contact-number>
                </div>
            </div>

            <!-- input email -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-email@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-email inputId="register-email"
                                v-model="registerModel.email"
                                :inputLbl="lbl.register.email"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="false"
                                :errorInfo="errorInfo[4]"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-email>

                </div>
            </div>

            <!-- input address text -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-address@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-text-area inputId=""
                                     v-model="addressModel.strAddress"
                                     :inputLbl="lbl.register.address"
                                     :isFirstSave="isFirstSave"
                                     :isShowErrorLbl="false"
                                     :errorInfo="errorInfo[5]"
                                     :showLblOnlyHasInput="true"
                    ></input-text-area>
                </div>
            </div>

            <!-- form address -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                </div>
                <div class="col-10 wrap-form-address">
                    <form-address
                        formId="form-address-register"
                        :address="addressModel"
                        :lblShipping="lbl.shipping"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="false"
                        :zipcodeError="errorInfo[6]"
                        :provinceError="errorInfo[7]"
                        :districtError="errorInfo[8]"
                        :subDistrictError="errorInfo[9]"
                    ></form-address>
                </div>
            </div>




            <!-- <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="text-red pt-1">*</div>
                    <div class="icon-register-input">
                        <div class="customCheckbox">
                            <label class="container">
                                <input type="checkbox" checked="checked">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-10 d-flex justify-content-end">

                </div>
            </div> -->
            <!-- <div class="text-center pt-4">
                <term-condition-modal></term-condition-modal>
            </div> -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                </div>
                <div class="col-10 wrap-btn-continue">
                    <button class="btn-black" @click="clickContinue()">{{lbl.default.continue}}</button>
                </div>
            </div>
            <!-- <div class="wrap-btn-continue">
                <button class="btn-black" @click="clickContinue()">{{lbl.default.continue}}</button>
            </div> -->

        </div><!-- .page-register-form -->

        <register-success-modal
            view="register-form"
            :busModal="busRegisterSuccess"
        ></register-success-modal>
        <modal view="register-form" :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Locale from "@/helper/locale/locale.js";
import TopBar from "@/components/TopBar.vue";
// import Util from "@/helper/Utility.js";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper";
//component
import InputText from "@/components/common/input/Text.vue";
import InputEmail from "@/components/common/input/Email.vue";
import DropdownDate from "@/components/common/input/DropdownDate.vue";
import InputTextArea from "@/components/common/input/TextArea.vue";
import InputContactNumber from "@/components/common/input/ContactNumber.vue";
import FormAddress from "@/components/common/form/FormAddressDropDown.vue";
// import TermConditionModal from "@/components/modal/TermConditionModal.vue";
import RegisterSuccessModal from "@/components/modal/RegisterSuccess.vue";
import Modal from "@/components/modal/Modal.vue";
//service
import { DiorRegisterModel } from "@/model/Dior/DiorRegisterModel.js";
import { AddressModel } from "@/model/AddressModel.js";
import DiorApi from "@/service/dior/DiorApi.js";
import LineFunction from '@/helper/facade/LineFunction.js';

export default {
    name: "RegisterForm",
    components: {
        TopBar,
        InputText,
        InputEmail,
        DropdownDate,
        InputTextArea,
        InputContactNumber,
        FormAddress,
        RegisterSuccessModal,
        Modal,
    },
    props: {
        registerData: Object,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),

            isFirstSave: true,
            errorInfo: [],
            prefix: '',

            registerModel: new DiorRegisterModel(),
            addressModel: null,

            busRegisterSuccess: new Vue(),
            busModal: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {


        var formInputCount = 10;
        for (var i=0 ; i<formInputCount ; i++) {
            this.errorInfo.push({ isValid: true, msg: '',});
        }

        this.addressModel = new AddressModel();
        this.registerModel.contactNumber = this.registerData.contactNumber;
        this.registerModel.birthday = this.registerData.day;
        this.registerModel.birthmonth = this.registerData.month;
        this.registerModel.lineUserId = Account.getLineUserId();
        this.registerModel.prefix = "MS";
        // console.log(this.registerData);
        // var account = Account.getLineUserId();
        // Util.log(account);

        // test register
        // this.registerData.day = "05";
        // this.registerData.month = "04";
        // this.registerModel.contactNumber = "0838019755"
    },
    mounted: function() {

    },
    methods: {
        clickContinue: function() {
            console.log("registerform");
            this.isFirstSave = false;
            if (this.validateForm()) {
                this.registerModel.address = this.addressModel;
                var params = this.registerModel.getParams();
                // console.log(params);
                if (params.address) {

                    params.address = params.address.replace(/\r?\n|\r/g, " ");
                }
                this.sendRegister(params);
                this.tracking.event('register_information', 'click_register_information');
            }
            // Util.log("address model", this.addressModel);
        },
        validateForm: function() {
            for (var i in this.errorInfo) {
                if (i >= 4 && i<= 9) {
                    break;
                }
                if (!this.errorInfo[i].isValid) {
                    return false;
                }
            }
            return true;
        },
        onDateChange: function(data) {
            this.registerModel.birthyear = data.year;
        },
        initLiff: function() {
            return new Promise((resolve) => {
                var lineFunction = new LineFunction();
                this.liffId = lineFunction.getLiffId();

                lineFunction.init(this.liffId).then(() => {

                    this.lineIdToken = lineFunction.getIdToken();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    this.setNotLineRegister();
                    // this.$router.replace('/error');
                });
            });

        },
        sendRegister: async function(params) {
            await this.initLiff();
            var token = Account.getToken();
            this.showLoading();
            DiorApi.registerMember(token, params, this.lineIdToken).then((res) => {
                this.hideLoading();
                console.log(res.data);
                this.showSuccess(this.lbl.register.register_completed, this.lbl.register.welcome_to_dior, this.lbl.default.continue, "success");
            }).catch((err) => {
                this.hideLoading();
                this.showSuccess(this.lbl.register.register_not_complete, this.lbl.register.try_again, this.lbl.default.continue, "notsuccess");
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();

                }
            });
        },
        ClickRadio: function(prefix) {

            this.registerModel.prefix = prefix;
        },
        showSuccess: function(title, message, btnOk, tag) {

             var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,

            };

            this.busRegisterSuccess.$emit('showModal', configModal);
            const bzbConfig = Vue.bzbsConfig;
            const appId = bzbConfig.client_id;
            let trackLabel = this.registerModel.lineUserId + "," + appId + "," + this.registerModel.contactNumber;
            this.tracking.event('register_success', 'click_register_success',trackLabel);
        },
        showErrorConnectModal: function() {

            var configModal = {

                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal');
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal');
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "../../style/page/RegisterForm.scss";
    // @import "@/style/base/component/baseinput.scss";
</style>
